$('.block--video').each(function(){
    
    const $el = $(this);
    const $videoContainer = $el.find('.block__image__video');
    const $videoElement = $videoContainer.find('video');
    const $playButton = $videoContainer.find('.button--play');
    const $pauseButton = $videoContainer.find('.button--pause');
    
    console.log($el);
    if($videoContainer.hasClass('start--mouseover')) {
        $el.on('mouseover', function(){
            $videoElement.css('display', 'block');
            $videoElement.trigger('play');
        });

        $el.on('mouseout', function(){
            $videoElement.css('display', 'none');
            $videoElement.trigger('pause');
        });
    }

    $playButton.on('click', function(){
        $pauseButton.css('display', 'block');
        $playButton.css('display', 'none');

        $videoElement.css('display', 'block');
        $videoElement.trigger('play');
    })

    $pauseButton.on('click', function(){   
        $pauseButton.css('display', 'none');
        $playButton.css('display', 'block');

        $videoElement.trigger('pause');
    })
})